import { render, staticRenderFns } from "./ProjectHeaderPreliminary.vue?vue&type=template&id=cb457750&"
import script from "./ProjectHeaderPreliminary.vue?vue&type=script&lang=js&"
export * from "./ProjectHeaderPreliminary.vue?vue&type=script&lang=js&"
import style0 from "./ProjectHeaderPreliminary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb457750')) {
      api.createRecord('cb457750', component.options)
    } else {
      api.reload('cb457750', component.options)
    }
    module.hot.accept("./ProjectHeaderPreliminary.vue?vue&type=template&id=cb457750&", function () {
      api.rerender('cb457750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/projects/ProjectHeaderPreliminary.vue"
export default component.exports